import LoadingObject, { LoadingObjectType } from '@/components/view/atoms/loading/LoadingObject'
import Area from '@/components/view/layouts/area/Area'
import AreaContent from '@/components/view/layouts/area/AreaContent'
import Content from '@/components/view/layouts/page/Content'
import Main, { MainLayoutType } from '@/components/view/layouts/page/Main'
import ContentEditLoading from '@/components/view/molecules/loading/ContentEditLoading'

export const FormLoading = () => (
  <Area>
    <AreaContent>
      <LoadingObject type={LoadingObjectType.INPUT_THIN} />
      <LoadingObject type={LoadingObjectType.TEXT} />
      <LoadingObject type={LoadingObjectType.TEXT} />
      <LoadingObject type={LoadingObjectType.TEXT_SHORT} />
    </AreaContent>
  </Area>
)

interface Props {
  withSide?: boolean
  isStore?: boolean
  small?: boolean
}

const PageEditLoading = ({ withSide = false, small = false }: Props) => {
  return (
    <Main type={small ? MainLayoutType.SMALL : MainLayoutType.MEDIUM}>
      <div className='flex items-center justify-between gap-4 py-6'>
        <LoadingObject type={LoadingObjectType.BUTTON} />
        <LoadingObject type={LoadingObjectType.BUTTON} />
      </div>
      <Content>
        <Area>
          <div className='flex items-center gap-4 px-6 py-4.5'>
            <LoadingObject type={LoadingObjectType.TAB} />
            <LoadingObject type={LoadingObjectType.TAB} />
          </div>
        </Area>
        <ContentEditLoading center withSide={withSide} />
      </Content>
    </Main>
  )
}

export default PageEditLoading
